/**
 * API Client Utility
 * 
 * This module provides a singleton instance of the configured axios client
 * for use by all API service implementations. It re-exports the api instance
 * from the main api service module to maintain backward compatibility.
 * 
 * @module apiClient
 */

import { api } from '../services/api';

/**
 * ApiClient class provides a singleton pattern wrapper around the axios instance
 */
class ApiClient {
  private static instance = api;

  /**
   * Get the singleton axios instance
   * @returns {AxiosInstance} The configured axios instance
   */
  static getInstance() {
    return this.instance;
  }
}

export default ApiClient;